import config from '../../config';
import { authFetch as fetch } from '../../common/authentication';

export default function preferencesMiddleware(store) {
  return (next) => (action) => {
    switch (action.type) {
      case 'preferences/get':
        getPreferences()
            .then((payload) => {
                store.dispatch({
                    type: 'preferences/update',
                    payload: payload,
                });
            })
            .catch((error) => {
                console.log(error);
                // A page waiting for the saved currency goes on with the default.
                store.dispatch({ type: 'preferences/loadFailed' });
            });
        break;
      case 'preferences/save': {
        // The save reaches the store at once, so a save sent before this one is acknowledged
        // still carries it. It is acknowledged as a save, never as a load.
        store.dispatch({ type: 'preferences/saved', payload: action.payload });
        const { loaded, ...prefs } = store.getState().preferences;
        savePreferences(prefs);
        break;
      }
        default:
            return next(action);
    }
  };
}

export function getPreferences() {
    return new Promise((resolve,reject) => {
        fetch(config.endpoints.preferences, {
            headers: { 'Content-Type': 'application/json' },
        })
        .then((res) => {
            return res.json()
        })
        .then((result) => resolve(result))
        .catch(reject);
    });
}

export function savePreferences(preferences) {
  return new Promise((resolve) => {
    fetch(config.endpoints.preferences, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(preferences),
    }).then((result) => resolve());
  });
}
